import { useLocation, useParams } from 'react-router-dom'
import Card from '@mui/material/Card'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDButton from 'components/MDButton'
import { useEffect, useState } from 'react'
import axios from 'axios'

function GoHighLevel() {
  const { search } = useLocation()
  const type = new URLSearchParams(search).get('type')
  const { companyId, app_id, locationId } = useParams()
  const clientsecret = "cTqSohCoMCOkEz6K1PbCWJ2rBfvxpIfeLxLgfXYeLQOR024oaUxHadoLczI3FJNt";
  const client_id = "app-2758041";
  const [isConnected, setIsConnected] = useState(false)
  // const webhookneed to register="https://webhook.alltheapps.io/v1/printful?location_id=asdfasdfasdfasdf&app_id=sdfsdfsdf&companyid=asdkfajsdfjasjdfasjd";
  const baseurl="https://app.alltheapps.io/integrations/printful/";
  // const baseurl = "http://localhost/integrations/printful/"
  const auth_url = `https://www.printful.com/oauth/authorize?client_id=${client_id}&redirect_url=${encodeURIComponent(`${baseurl}`)}&state=${encodeURIComponent(`${locationId},${companyId},${app_id},${clientsecret},${client_id}`).replace(/\s+/g, '')}`;
  const handleConnect = (e) => {
    e.preventDefault()
    window.open(auth_url, '_blank')
    setIsConnected(true)
  }


  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundSize: 'cover',
      }}
    >
      <Card
        sx={{
          width: '35%',
          textAlign: 'center',
          padding: '2rem',
          borderRadius: '29px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        }}
      >
        <MDTypography variant="h4" gutterBottom style={{ color: 'black' }}>
          Connect with printfull
        </MDTypography>

        {!isConnected ? (
          <MDBox component="form" onSubmit={handleConnect} sx={{ mt: 5 }}>
            <MDButton
              type="submit"
              variant="contained"
              color="info"
              fullWidth
              sx={{ mt: 2 }}
              style={{ fontSize: '0.9rem', textTransform: 'capitalize', padding: '0 5rem' }}
            >
              Connect
            </MDButton>
          </MDBox>
        ) : (<>
          <MDBox component="form" onSubmit={(e) => e.preventdefault()} sx={{ mt: 5 }}>
            <MDButton
              type="button"
              variant="contained"
              color="info"
              fullWidth
              sx={{ mt: 2 }}
              style={{ fontSize: '0.9rem', textTransform: 'capitalize', padding: '0 5rem' }}
            >
              Already Connected
            </MDButton>
          </MDBox>
        </>)}

      </Card>
    </div>
  )
}

export default GoHighLevel
